
interface Device {
  MAC: string;
  id: string;_id: string;
}
interface Client {
  name: string;
  id: string;_id: string;
}
import { defineComponent, onMounted, ref, computed } from "vue";
import ClientsTable from "@/components/widgets/sistena/ClientsTable.vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import firebaseAuth from "firebase";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import firebase from "firebase/app";
export default defineComponent({
  name: "account-overview",
  props:{
    model: String
  },
  
  setup() {
    // Estados para alta de modelos
  const modelName = ref("");
    const deviceDescription = ref("");
    const icon = ref("");
    const registerDescription = ref("");
    // Formatear JSON para vista previa
    function formatJson(jsonStr: string) {
      try {
        return JSON.stringify(JSON.parse(jsonStr), null, 2);
      } catch {
        return jsonStr;
      }
    }
    // Guardar modelo
    const saveModel = async () => {
      const payload = {
        model: modelName.value,
        deviceDescription: deviceDescription.value,
        icon: icon.value,
        registerDescription: registerDescription.value
      };
      await ApiService.post("models", payload).then((response) => {
        console.log('Modelo guardado:', response.data);
        Swal.fire({
            text: `Modelo ${modelName.value} guardado exitosamente`,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary"
            }
          })
        
      }).catch((error) => {
        console.error('Error al guardar modelo:', error);
        alert('Error al guardar modelo');
      });
      modelName.value = "";
      deviceDescription.value = "";
      icon.value = "";
      registerDescription.value = "";
    };
    // Estados reactivos para asociación dispositivo-cliente
    const listDevices = ref<Device[]>([]);
    const listClients = ref<Client[]>([]);
    const selectedDevice = ref<Device | null>(null);
    const selectedClient = ref<Client | null>(null);
    const listModels = ref<any[]>([]);
    const deviceInput = ref("");
    const clientInput = ref("");
    const clientName = ref("");
    const clientEmail = ref("");
    const distributorName = ref("");
    const macDevice = ref("");
    const wifiModuleDevice = ref("");
    const selectedModel = ref<any>(null);
    const selectedClients = ref<string[]>([]);
    const showDeviceOptions = ref(false);
    const showClientOptions = ref(false);
    const filteredDevices = computed(() => listDevices.value.filter(d => d.MAC && d.MAC.toLowerCase().includes(deviceInput.value.toLowerCase())));
    const filteredClients = computed(() => listClients.value.filter(c => c.name && c.name.toLowerCase().includes(clientInput.value.toLowerCase())));
    
    function selectDevice(device: Device) {
      selectedDevice.value = device;
      deviceInput.value = device.MAC;
      showDeviceOptions.value = false;
    }
    function selectClient(client: Client) {
      selectedClient.value = client;
      clientInput.value = client.name;
      showClientOptions.value = false;
    }
    function hideDeviceOptions() {
      setTimeout(() => { showDeviceOptions.value = false; }, 150);
    }
    function hideClientOptions() {
      setTimeout(() => { showClientOptions.value = false; }, 150);
    }function formatMac() {
      macDevice.value = (macDevice.value || "").toUpperCase().replace(/\s+/g, "");
    }
    function onPasteMac(event: ClipboardEvent) {
      const pasted = (event.clipboardData || (window as any).clipboardData).getData("text") || "";
      macDevice.value = pasted.toUpperCase().replace(/\s+/g, "");
    }
    // Cargar datos al montar
    onMounted(async () => {
      setCurrentPageBreadcrumbs("Overview", ["Account"]);
      await ApiService.setHeader();
      const devicesRes = await ApiService.get("devices");
      listDevices.value = devicesRes.data.devices || [];
      const clientsRes = await ApiService.get("clients");
      listClients.value = clientsRes.data.clients || [];
      const models = await ApiService.get("models");
      listModels.value = models.data || [];
      const collapseEl = document.getElementById("collapseAssociateDeviceClient");
  if (collapseEl) {
    collapseEl.addEventListener("shown.bs.collapse", async () => {
      await ApiService.setHeader();
      const clientsRes = await ApiService.get("clients");
      listClients.value = clientsRes.data.clients || [];
    });
  }
    
    });
    // Lógica para enviar al API
    const associateDeviceWithClient = async () => {
      if (!selectedDevice.value || !selectedClient.value) {
        console.error('Selecciona dispositivo y cliente');
        return;
      }
      console.log(selectedDevice.value._id, selectedClient.value._id);
      await ApiService.post("devices/link/client", {
        deviceId: selectedDevice.value._id,
        clientId: selectedClient.value._id
      }).then((response) => {
        console.log('Asociación exitosa:', response.data);
        Swal.fire({
            text: `Dispositivo ${selectedDevice.value?.MAC} asociado a cliente ${selectedClient.value?.name}`,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary"
            }
          })
        
      }).catch((error) => {
        console.error('Error en asociación:', error);
        alert('Error al asociar dispositivo y cliente');
      });
      selectedDevice.value = null;
      selectedClient.value = null;
      deviceInput.value = "";
      clientInput.value = "";
    };
    const selectedClientForDevice = ref<Client | null>(null);
    const saveChangesDevice = async () =>{
      // Ensure MAC normalized
      const safeMac = (macDevice.value || "").toUpperCase().replace(/\s+/g, "");
      const apiDataDev = {
        MAC: safeMac,
        wifiModule: wifiModuleDevice.value,
        device: selectedModel.value ? selectedModel.value.model : null
      };

      try {
        const response = await ApiService.post("admin/register/device", apiDataDev);
        const created = response.data || {};
        // intentar obtener id de varias formas comunes
        const deviceId = await ApiService.get("/devices/byMAC/" + safeMac).then(res => res.data.devices[0]._id).catch(() => null);

        // Si se seleccionó cliente, asociar
        if (selectedClientForDevice.value) {
          const clientId = selectedClientForDevice.value._id || selectedClientForDevice.value.id;
          if (deviceId && clientId) {
            await ApiService.post("devices/link/client", {
              deviceId,
              clientId
            });
          }
        }

        Swal.fire({
          text: `Dispositivo con MAC ${safeMac} creado${selectedClientForDevice.value ? " y asociado al cliente " + selectedClientForDevice.value.name : ""} exitosamente`,
          icon: "success",
          buttonsStyling: false,
          confirmButtonText: "Ok, got it!",
          customClass: { confirmButton: "btn fw-bold btn-light-primary" }
        });

        // limpiar formulario
        macDevice.value = "";
        wifiModuleDevice.value = "";
        selectedModel.value = null;
        selectedClientForDevice.value = null;

      } catch (err) {
        console.error('Error al crear dispositivo o asociar:', err);
        Swal.fire({
          text: `Error al crear o asociar dispositivo: ${err?.message || err}`,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: { confirmButton: "btn fw-bold btn-light-danger" }
        });
      }
    };
    const saveChangesDistributor = async () => {
      // Handle form submission
      // You can access the form data in this.distributorName and this.selectedClients
      console.log('Distributor Name:', distributorName.value);
      console.log('Selected Clients:', selectedClients.value);
    };
    const saveChangesClient = async () => {
  // Crea una app secundaria para registrar el usuario sin cambiar el usuario actual
    const secondaryApp = firebase.initializeApp(firebase.app().options, "Secondary");
      try {
        const userCredential = await secondaryApp.auth().createUserWithEmailAndPassword(clientEmail.value, "Sistena01");
        const usercreate = userCredential.user;
        if (usercreate) {
          const apiData = {
            name: clientName.value,
            email: clientEmail.value,
            firebaseUid: usercreate.uid
          };
          await ApiService.post("clients/", apiData);
          clientEmail.value = "";
          clientName.value = "";
          Swal.fire({
            text: `Cliente ${apiData.name} creado exitosamente`,
            icon: "success",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn fw-bold btn-light-primary"
            }
          });
        } else {
          Swal.fire({
            text: "No se pudo crear el usuario en Firebase.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok",
            customClass: {
              confirmButton: "btn fw-bold btn-light-danger"
            }
          });
        }
      } catch (error) {
        Swal.fire({
          text: `Error al crear usuario}`,
          icon: "error",
          buttonsStyling: false,
          confirmButtonText: "Ok",
          customClass: {
            confirmButton: "btn fw-bold btn-light-danger"
          }
        });
      }
      // Cierra la sesión secundaria
      await secondaryApp.auth().signOut();
      secondaryApp.delete();
    };
  return {
   modelName,
      deviceDescription,
      icon,
      registerDescription,
      formatJson,
      saveModel,
      listDevices,
      listClients,
      listModels,
      macDevice,
      formatMac,
      onPasteMac,
      wifiModuleDevice,
      selectedModel,
      selectedDevice,
      selectedClient,
      selectedClients,
      deviceInput,
      clientInput,
      distributorName,
      clientEmail,
      clientName,
      saveChangesClient,
      saveChangesDistributor,
      saveChangesDevice,
      showDeviceOptions,
      showClientOptions,
      filteredDevices,
      filteredClients,
      selectDevice,
      selectClient,
      hideDeviceOptions,
      hideClientOptions,
      associateDeviceWithClient,
      selectedClientForDevice,
    };
  // ...ya definido arriba en Composition API...
  },
});
